import { render, staticRenderFns } from "./KnowledgeBasePosts.vue?vue&type=template&id=bb9c1c30&scoped=true"
import script from "./KnowledgeBasePosts.vue?vue&type=script&lang=js"
export * from "./KnowledgeBasePosts.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBasePosts.vue?vue&type=style&index=0&id=bb9c1c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9c1c30",
  null
  
)

export default component.exports